import React from 'react'
import { observer } from 'mobx-react'
import { classNames as cn } from 'helpers'
import styles from 'components/UI/TextArea/TextArea.module.scss'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormField from 'components/UI/AsideModal/Form/FormField'
import asideModalStore from 'Stores/asideModalStore'
import useLocalization from 'hooks/useLocalization'

const ChangeClientGroupComment = () => {
  const { modalValues, changeValue, check } = asideModalStore

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      comment: 'Comment',
    },
  })

  return (
    <FormField>
      <FormLabel>{translate?.comment}:</FormLabel>
      <textarea
        placeholder={translate?.comment}
        value={modalValues?.text}
        onChange={(e) => changeValue(e.target.value, 'text')}
        className={cn({
          [styles.textarea]: true,
          [styles.error]: check('text'),
        })}
      />
    </FormField>
  )
}

export default observer(ChangeClientGroupComment)
